import { useState } from "react"
import { CustomModal } from "@components"

import {
  Autocomplete,
  AutocompleteItem,
  Button, 
  ModalContent, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
} from "@heroui/react";

import PropTypes from 'prop-types';

const LocationsModal = ({
  description,
  handleClose,
  handleSave,
  initialLocation = null,
  isSaving,
  locations,
  show,
  title = "Locations Selector" 
}) => {
  const [selectedLocation, setSelectedLocation] = useState(initialLocation);

  return (
    <CustomModal
      isOpen={show}
      size="xl"
      handleClose={() => handleClose()}
      scrollBehavior="outside"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>{title}</ModalHeader>
          
            <ModalBody>
              <div className="mt-4">
                <p className="mb-2 text-content2-foreground">{description}</p>

                <div className="flex items-center gap-2">
                  <Autocomplete placeholder="Select a location" onSelectionChange={setSelectedLocation} selectedKey={selectedLocation}>
                    {locations.map((location) => (
                      <AutocompleteItem key={location.id}>{location.name}</AutocompleteItem>
                    ))}
                  </Autocomplete>

                  <Button color="default" className="text-white" onPress={() => setSelectedLocation(null)} isDisabled={!selectedLocation}>
                    Remove
                  </Button>
                </div>
              </div>
            </ModalBody>

            <ModalFooter>
              <div className="flex justify-between w-full">
                <Button onPress={() => handleClose()} tabIndex={-1}>Cancel</Button>
                <Button color="secondary" onPress={() => handleSave(selectedLocation)} tabIndex={-1} isLoading={isSaving}>Save</Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </CustomModal>
  )
}

LocationsModal.propTypes = {
  description: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  initialLocation: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isSaving: PropTypes.bool,
  locations: PropTypes.array.isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
}

export default LocationsModal